const sectionProductsList = document.querySelectorAll('.products-list');

sectionProductsList.forEach(list => {
  const contentItem = list.querySelectorAll('.contents__item');

  contentItem.forEach(item => { 
    const swiper = item.querySelector('.swiper');  
    const nextButtons = item.querySelectorAll('.swiper-button-next');
    const prevButtons = item.querySelectorAll('.swiper-button-prev');


    const productsListSwiper = new Swiper(swiper, {
      pagination: {
        el: swiper.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: nextButtons[0],
        prevEl: prevButtons[0], 
      },
      loop: false,
      centeredSlides: false,
      slidesPerView: 2,
      spaceBetween: 20,
      autoHeight: false,
      breakpoints: {
        749: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        }
      }
    });

    nextButtons.forEach((button, index) => {
      if (index !== 0) { 
        button.addEventListener('click', () => {
          productsListSwiper.slideNext();
        });
      }
    });

    prevButtons.forEach((button, index) => {
      if (index !== 0) { 
        button.addEventListener('click', () => {
          productsListSwiper.slidePrev();
        });
      }
    });
  });
});

if (typeof apparitionFromRight === 'undefined') {
  
  const apparitionFromRight = document.querySelectorAll('.apparition-from-right');
  
  const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
          if (entry.isIntersecting) {
              entry.target.classList.add('animate');
          }
      });
  }, {
      threshold: 0.1,
  });
  
  apparitionFromRight.forEach((el) => observer.observe(el));
    
}

/* TAB TRANSITION */

sectionProductsList.forEach(list => {
  const tabs = list.querySelectorAll('.products-list__tabs .tab__item');
  const contents = list.querySelectorAll('.products-list__contents .contents__item');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      contents.forEach(content => {
        content.classList.remove('active');
        content.style.display = 'none';
      });

      const newContent = Array.from(contents).find(content => content.id === tab.id);

      if (newContent) {
        newContent.style.display = 'block';

        setTimeout(() => {
          newContent.classList.add('active');
        }, 10);
      }
    });
  });
});


/* PRODUCTS HREF */

sectionProductsList.forEach(list => {
  const products = list.querySelectorAll('.products-list__contents .product__item');

  products.forEach(product => {
    product.addEventListener('click', () => {
      const productPageUrl = product.getAttribute('href');
      if (productPageUrl) {
        window.location.href = productPageUrl;
      }
    });
  });
});
